<div class="tf-checkbox-container">
    <div class="checkbox"
         [attr.id]="id"
         (click)="handleClick($event)">
        <input type="checkbox"
               [name]="name"
               [value]="value"
               [checked]="checked"
               [disabled]="disabled"
               (blur)="onBlur()">
        <span [ngClass]="getCheckmarkClass()"></span>
    </div>
    <label class="label"
           *ngIf="label"
           (click)="handleClick($event)"
           [title]="label"
           [innerHtml]="label">
    </label>
</div>
